import React from 'react';
import PropTypes from 'prop-types';

import { getCheckoutPartProps } from '../../../pages/ReviewOrder/reviewOrderBrandRefreshClasses';
import styles from './CheckoutAlertInline.module.css';

const warningCircleIcon = require('../imgs/brand-refresh-warning-circle.svg');

const CheckoutAlertInline = ({ message, className, id }) => {
  if (!message) {
    return null;
  }

  return (
    <div
      id={id}
      className={[styles.alert, className].filter(Boolean).join(' ')}
      role="alert"
      data-part={getCheckoutPartProps('alert-inline')}
    >
      <div
        className={styles.iconWrap}
        data-part={getCheckoutPartProps('alert-inline-icon')}
      >
        <img
          className={styles.icon}
          src={warningCircleIcon}
          alt=""
          aria-hidden="true"
        />
      </div>
      <p
        className={styles.message}
        data-part={getCheckoutPartProps('alert-inline-message')}
      >
        {message}
      </p>
    </div>
  );
};

CheckoutAlertInline.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
};

CheckoutAlertInline.defaultProps = {
  message: '',
  className: '',
  id: undefined,
};

export default CheckoutAlertInline;
